<template>
  <div id="change-password">
    <h2 class="title">Cambiar Contraseña</h2>
    <form class="card" @submit.prevent="submitForm">
      <div class="flex form-group column-sm column-m">
        <label class="label">Contraseña Actual</label>
        <div class="flex column grow-1">
          <input type="password" class="input" v-model="password" />
          <span
            v-if="errors.password.length"
            class="error"
          >
            {{ errors.password[0] }}
          </span>
        </div>
      </div>
      <div class="flex form-group column-sm column-m">
        <label class="label">Nueva Contraseña</label>
        <div class="flex column grow-1">
          <input type="password" class="input" v-model="new_password" />
          <span
            v-if="errors.newPassword.length"
            class="error"
          >
            {{ errors.newPassword[0] }}
          </span>
        </div>
      </div>
      <div class="flex form-group column-sm column-m">
        <label class="label">Confirmar nueva contraseña</label>
        <div class="flex column grow-1">
          <input type="password" class="input" v-model="password_confirmation" />
          <span
            v-if="errors.passwordConfirmation.length"
            class="error"
          >
            {{ errors.passwordConfirmation[0] }}
          </span>
        </div>
      </div>
      <button class="btn">
        Cambiar Contraseña
      </button>
    </form>
    <ErrorModal
      @confirm="showErrorModal = false"
      :active="showErrorModal"
      message="Hubo un error, verifica tus datos y vuelve a intentar"
    />
    <SuccessModal
      @confirm="showSuccessModal = false"
      :active="showSuccessModal"
      message="Se ha actualizado tu contraseña correctamente"
    />
  </div>
</template>

<script>
import { changePassword } from '@/api/users'
import ErrorModal from '@/components/ErrorModal'
import SuccessModal from '@/components/SuccessModal'

export default {
  name: 'ChangePassword',
  components: {
    ErrorModal,
    SuccessModal
  },
  data () {
    return {
      password: '',
      new_password: '',
      password_confirmation: '',
      showErrorModal: false,
      showSuccessModal: false,
      errors: {
        password: [],
        newPassword: [],
        passwordConfirmation: []
      }
    }
  },
  methods: {
    cleanErrors () {
      this.errors = {
        password: [],
        newPassword: [],
        passwordConfirmation: []
      }
    },
    submitForm () {
      this.cleanErrors()

      if (this.password.length < 6) {
        this.errors = { ...this.errors, password: ['La contraseña debe ser mayor a 6 caracteres'] }
      }
      if (this.new_password.length < 6) {
        this.errors = { ...this.errors, newPassword: ['La nueva contraseña debe ser mayor a 6 caracteres'] }
      }
      if (this.password_confirmation.length < 6) {
        this.errors = { ...this.errors, passwordConfirmation: ['La confirmación de contraseña debe ser mayor a 6 caracteres'] }
      }
      if (this.new_password !== this.password_confirmation) {
        this.errors = {
          ...this.errors,
          newPassword: [...this.errors.newPassword, 'La nueva contraseña y la confirmación de contraseña deben coincidir'],
          passwordConfirmation: [...this.errors.passwordConfirmation, 'La nueva contraseña y la confirmación de contraseña deben coincidir']
        }
      }

      if (!this.errors.password.length && !this.errors.newPassword.length && !this.errors.passwordConfirmation.length) {
        this.sendData()
      }
    },
    sendData () {
      const data = {
        password: this.password,
        new_password: this.new_password,
        password_confirmation: this.password_confirmation
      }

      changePassword(data).then(response => {
        this.password = ''
        this.new_password = ''
        this.password_confirmation = ''
        this.showSuccessModal = true
      }).catch(_ => {
        this.password = ''
        this.new_password = ''
        this.password_confirmation = ''
        this.showErrorModal = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#change-password {
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color: $grey;
}

.card {
  border-radius: 1.5rem;
  background-color: white;
  padding: 1rem 2rem;
  width: 40rem;
}

.form-group {
  margin: 1rem 0;
}

.label {
  text-align: left;
  width: 15rem;
}

.input {
  padding: 0.5rem 0.25rem;
  background-color: $light-grey;
  border-radius: 20px;
  border-width: 0;

  &:focus {
    outline-width: 0;
  }
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.error {
  text-align: left;
  font-size: 0.75rem;
  color: $red;
}

@media(max-width: 60rem) {
  .card {
    width: auto;
  }

  .label, .input {
    width: 100%;
  }
}
</style>
